const MealTypesCategories = () => import("../mealTypesCategories/views/MealTypesCategories.vue");
const MealTypesCategoryEdit = () =>
  import("../mealTypesCategories/views/MealTypesCategoryEdit.vue");

const route = "/mealTypesCategories";

export default [
  {
    path: route,
    name: "mealTypesCategories.list",
    component: MealTypesCategories,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "mealTypesCategories.create",
    component: MealTypesCategoryEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:mealTypesCategoryId/edit`,
    name: "mealTypesCategories.edit",
    component: MealTypesCategoryEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
